import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import '@/App.css';

// Pages
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Programs from './pages/Programs';
import ProgramDetail from './pages/ProgramDetail';
import Challenges from './pages/Challenges';
import Tracker from './pages/Tracker';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Mindset from './pages/Mindset';
import Academia from './pages/Academia';
import AcademiaContent from './pages/AcademiaContent';
import Coaching from './pages/Coaching';
import About from './pages/About';
import Testimonials from './pages/Testimonials';
import FreeContent from './pages/FreeContent';
import Contact from './pages/Contact';
import Success from './pages/Success';
import ChallengeSuccess from './pages/ChallengeSuccess';
import ChallengeDetail from './pages/ChallengeDetail';
import ChallengeNutrition from './pages/ChallengeNutrition';
import MyChallenges from './pages/MyChallenges';
import AdminDashboard from './pages/AdminDashboard';
import AdminChallenges from './pages/AdminChallenges';
import AdminPodcasts from './pages/AdminPodcasts';
import AdminBlog from './pages/AdminBlog';
import AdminContent from './pages/AdminContent';
import AdminContentStats from './pages/AdminContentStats';
import AdminProgramContent from './pages/AdminProgramContent';
import AdminIncome from './pages/AdminIncome';
import AdminUsers from './pages/AdminUsers';
import AdminClients from './pages/AdminClients';
import AdminClubVIP from './pages/AdminClubVIP';
import ProgramRoutine from './pages/ProgramRoutine';
import NutritionPlan from './pages/NutritionPlan';
import NutritionForm from './pages/NutritionForm';
import NutritionFormLevel2 from './pages/NutritionFormLevel2';
import NutritionFormPremium from './pages/NutritionFormPremium';
import RecipeGenerator from './pages/RecipeGenerator';
import Ebooks from './pages/Ebooks';
import Checkout from './pages/Checkout';
import WompiSuccess from './pages/WompiSuccess';
import WompiSuccessPreview from './pages/WompiSuccessPreview';
import CompleteRegistration from './pages/CompleteRegistration';
import AdminLibraryExercises from './pages/AdminLibraryExercises';
import AdminSubscriptionPricing from './pages/AdminSubscriptionPricing';
import AdminTrainingTechniques from './pages/AdminTrainingTechniques';
import AdminUserRoutines from './pages/AdminUserRoutines';
import WorkoutForm from './pages/WorkoutForm';
import MyTrainingPlan from './pages/MyTrainingPlan';
import WorkoutDayDetail from './pages/WorkoutDayDetail';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';
import ProtectedRoute from './components/ProtectedRoute';
import PWAInstallPrompt from './components/PWAInstallPrompt';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/dashboard" element={<ProtectedRoute vipOnly><Dashboard /></ProtectedRoute>} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/programs/:id" element={<ProgramDetail />} />
          <Route path="/challenges" element={<Challenges />} />
          <Route path="/challenge/:challengeId" element={<ChallengeDetail />} />
          <Route path="/tracker" element={<ProtectedRoute vipOnly><Tracker /></ProtectedRoute>} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/mindset" element={<Mindset />} />
          <Route path="/academia" element={<Academia />} />
          <Route path="/academia/:contentId" element={<AcademiaContent />} />
          <Route path="/ebooks" element={<Ebooks />} />
          <Route path="/coaching" element={<Coaching />} />
          <Route path="/about" element={<About />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/free-content" element={<FreeContent />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/success" element={<Success />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/checkout/wompi-success" element={<WompiSuccess />} />
          <Route path="/wompi/success" element={<WompiSuccess />} />
          <Route path="/payment-success-preview" element={<WompiSuccessPreview />} />
          <Route path="/challenge-success" element={<ChallengeSuccess />} />
          <Route path="/complete-registration" element={<CompleteRegistration />} />
          <Route path="/my-challenges" element={<ProtectedRoute><MyChallenges /></ProtectedRoute>} />
          <Route path="/my-challenges/:challengeId" element={<ProtectedRoute><MyChallenges /></ProtectedRoute>} />
          <Route path="/challenge/:challengeId/nutrition" element={<ProtectedRoute><ChallengeNutrition /></ProtectedRoute>} />
          <Route path="/routine/:level/:day" element={<ProtectedRoute vipOnly><ProgramRoutine /></ProtectedRoute>} />
          <Route path="/nutrition/:level" element={<ProtectedRoute vipOnly><NutritionPlan /></ProtectedRoute>} />
          <Route path="/nutrition-form" element={<ProtectedRoute vipOnly><NutritionForm /></ProtectedRoute>} />
          <Route path="/nutrition-form-level2" element={<ProtectedRoute vipOnly><NutritionFormLevel2 /></ProtectedRoute>} />
          <Route path="/nutrition-form-premium" element={<ProtectedRoute vipOnly><NutritionFormPremium /></ProtectedRoute>} />
          <Route path="/recipes" element={<ProtectedRoute vipOnly><RecipeGenerator /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/income" element={<ProtectedRoute adminOnly><AdminIncome /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute adminOnly><AdminUsers /></ProtectedRoute>} />
          <Route path="/admin/clients" element={<ProtectedRoute adminOnly><AdminClients /></ProtectedRoute>} />
          <Route path="/admin/content-stats" element={<ProtectedRoute adminOnly><AdminContentStats /></ProtectedRoute>} />
          <Route path="/admin/challenges" element={<ProtectedRoute adminOnly><AdminChallenges /></ProtectedRoute>} />
          <Route path="/admin/podcasts" element={<ProtectedRoute adminOnly><AdminPodcasts /></ProtectedRoute>} />
          <Route path="/admin/blog" element={<ProtectedRoute adminOnly><AdminBlog /></ProtectedRoute>} />
          <Route path="/admin/content" element={<ProtectedRoute adminOnly><AdminContent /></ProtectedRoute>} />
          <Route path="/admin/programs" element={<ProtectedRoute adminOnly><AdminProgramContent /></ProtectedRoute>} />
          <Route path="/admin/club-vip" element={<ProtectedRoute adminOnly><AdminClubVIP /></ProtectedRoute>} />
          <Route path="/admin/library-exercises" element={<ProtectedRoute adminOnly><AdminLibraryExercises /></ProtectedRoute>} />
          <Route path="/admin/subscription-pricing" element={<ProtectedRoute adminOnly><AdminSubscriptionPricing /></ProtectedRoute>} />
          <Route path="/admin/training-techniques" element={<ProtectedRoute adminOnly><AdminTrainingTechniques /></ProtectedRoute>} />
          <Route path="/admin/user-routines" element={<ProtectedRoute adminOnly><AdminUserRoutines /></ProtectedRoute>} />
          <Route path="/training-plan" element={<ProtectedRoute vipOnly><MyTrainingPlan /></ProtectedRoute>} />
          <Route path="/training-plan/form" element={<ProtectedRoute vipOnly><WorkoutForm /></ProtectedRoute>} />
          <Route path="/training-plan/day/:dayNumber" element={<ProtectedRoute vipOnly><WorkoutDayDetail /></ProtectedRoute>} />
        </Routes>
        <Footer />
        <ChatWidget />
        <PWAInstallPrompt />
        <Toaster position="top-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;